import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Holds a block at the height it had last time until its content is in, so
 * the page doesn't grow under someone already reading or scrolling it.
 * Only the height is kept (no content), per salon and per layout, in this
 * browser. Returns [ref, minHeight]: the ref for the block, and the height to
 * hold it at while `ready` is false (undefined once it is, or when unknown).
 */
export function useHeldHeight(name, layout, ready) {
  const ref = useRef(null)
  let salon = ''
  try { salon = localStorage.getItem('salonId') || '' } catch (e) { /* private mode */ }
  const key = `beu-held-${name}-${salon}-${layout}`
  const [held] = useState(() => {
    try { return Number(localStorage.getItem(key)) || 0 } catch (e) { return 0 }
  })
  // Once it's in, its height is kept up to date (pictures land later), for next time
  useLayoutEffect(() => {
    const el = ref.current
    if (!ready || !el) return undefined
    const save = () => {
      const h = Math.round(el.getBoundingClientRect().height)
      if (h > 0) {
        try { localStorage.setItem(key, String(h)) } catch (e) { /* the next visit just won't hold */ }
      }
    }
    save()
    if (typeof ResizeObserver === 'undefined') return undefined
    const ro = new ResizeObserver(save)
    ro.observe(el)
    return () => ro.disconnect()
  }, [ready, key])
  return [ref, ready || !held ? undefined : held]
}

/** The home's layout at this width, as its CSS draws it: three columns, two or one. */
export const layoutAt = (width) => (width > 1100 ? 'wide' : width > 767 ? 'tablet' : 'phone')
